import { API_BASE_URL, ENDPOINTS } from "@/config/api.enpoints";
import apiClient from "./apiClient";

export const fetchSubscriptionData = async () => {
      const response = await apiClient.get(`${API_BASE_URL}${ENDPOINTS.SUBSCRIPTION.getSubscription}`);
      return response.data;
};